const modules = import.meta.glob<string>('./*.{png,jpg,svg}', { eager: true, as: 'url' });

export const galleriImages: Record<string, string> = Object.fromEntries(
    Object.entries(modules).map(([path, url]) => [path.slice(2), url])
);

import sentraltGalleri from './galleri.json';

interface GalleryJsonItem {
    filId: number;
    uri: string | null;
}

export function resolveGalleryUri(uri: string | null | undefined): string | null {
    if (!uri) return null;
    const filename = uri.split('/').pop();
    return (filename && galleriImages[filename]) || uri;
}

const filIdToUri: Record<number, string> = Object.fromEntries(
    (sentraltGalleri as GalleryJsonItem[])
        .filter(item => item.filId && item.uri)
        .map(item => [item.filId, item.uri as string])
);

const IMAGE_BASE_URL = 'https://dibk-drommeplan-dev.azurewebsites.net/api/Fil';

export function buildImageUrl(filId: string | number | null | undefined): string {
    if (!filId) return '';
    const str = String(filId);
    if (str.startsWith('http')) return str;
    const sentraltUri = filIdToUri[Number(str)];
    if (sentraltUri) return resolveGalleryUri(sentraltUri) ?? `${IMAGE_BASE_URL}/${str}`;
    return `${IMAGE_BASE_URL}/${str}`;
}
